import { createRequestActions, createAction } from "common/helpers/action";

export const initKkmSettings = createRequestActions("KKM.SETTINGS.INIT");
export const sendSettingKkmSettings = createRequestActions("KKM.SETTINGS.SENT_SETTING");
export const sendApiKeyKkmSettings = createRequestActions("KKM.SETTINGS.SEND_API_KEY");
export const sendHandlerKkmSettings = createRequestActions("KKM.SETTINGS.SEND_HANDLER");

export const successUpdateKkmSettings = createAction("KKM.SETTINGS.SUCCESS_UPDATE");
export const failureUpdateKkmSettings = createAction("KKM.SETTINGS.FAILURE_UPDATE");
